import mixGenerarPdf from '@/helpers/mixGenerarPdf';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';

export default {
  data() {
    return {
      generandoPdfCatalogoFavoritos: false,
    };
  },
  mixins: [mixGenerarPdf,
    mixFormatoEstructura,
  ],
  methods: {
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto);
    },
    async generarPdfCatalogoFavoritos() {
      this.generandoPdfCatalogoFavoritos = true;
      const nombreTemplate = 'templateInformeAvances';
      const datosContrato = this.formatoObjeto(this.getContrato);

      const datosFecha = this.formatoObjeto({
        fechaAl: this.AlaFecha,
      });
      const conceptos = this.getContratoCatalogoFavoritos
        .map((c) => ({
          nombre: c.nombreCorto,
          avance: c.porcentajeAvance,
        }));
      const logo = this.getCliente?.logo ? this.getCliente.logo : '';
      /*
      const graficaDatos = this.mixPuntosGrafica || {
        fechas: [], programado: [], financiero: [], fisico: [],
      }; */

      const fechas = this.getGraficaEjeX.map((fecha) => new Date(`${fecha} 00:00:0`).toLocaleDateString());

      // Arreglos para grafica
      const grafica = {
        fechas: ['', ...fechas],
        programado: [0, ...this.getGraficaProgramadoData.map(({ porcentaje }) => porcentaje)],
        financiero: [0, ...this.getGraficaEstimacionesData.map(({ porcentaje }) => porcentaje)],
        fisico: [0, ...this.getGraficaAvanceFisicoData.map(({ porcentaje }) => porcentaje)],
      };

      const porcentajeFisico = this.getPorcentajeAvanceFisicoAlaFecha;
      const porcentajeFinanciero = this.getPorcentajeFinanciero;
      const { nota } = this;
      const supervisionExterna = this.getContratoSupervisionExterna?.contratoRelacionado
        ?.contratista?.nombreRazonSocial || '';

      const foto = this.imagenSeleccionada ? this.imagenSeleccionada.split('/')[3] : '';
      // this.getUltimoReporteActividad?.imagenes[0].split('/')[3] || '';
      const fotoCroquis = this.imagenOtraImagen ? this.imagenOtraImagen.split('/')[3] : '';

      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: false,
            format: 'A3',
            footerTemplate: '',
          },
          nombreTemplate,
        },
        data: {
          contrato: datosContrato,
          fecha: datosFecha.fechaAl_texto.toUpperCase(),
          conceptos,
          logo,
          grafica,
          porcentajeFisico,
          porcentajeFinanciero,
          nota,
          supervisionExterna,
          foto,
          fotoCroquis,
          footer: '',
        },
      }, `${this.getContrato.numero}_InformeAvances_${this.AlaFecha}`);
      this.generandoPdfCatalogoFavoritos = false;
    },

  },
  computed: {
    getContratoSupervisionExterna() {
      return this.getContrato.contratosRelacionados
        .find(({ esSupervisionExterna }) => esSupervisionExterna === true);
    },
    getCliente() {
      if (!this.getContrato.cliente) return {};
      return this.getContrato.cliente;
    },
  },

};
